import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { AuthService } from 'src/app/shared/services/http/auth/auth.service';
import {
  MatSnackBar,
  MatSnackBarRef,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { ErrorSnackbarComponent } from 'src/app/components/error-snackbar/error-snackbar.component';
import { UtilService } from 'src/app/shared/services/util/util.service';
import { Subscription } from 'rxjs';
import { OtpType } from 'src/app/enums/assessment.enum';
import { ClientService } from 'src/app/shared/services/client.service';
@Component({
  selector: 'app-register-student-otp',
  templateUrl: './register-student-otp.component.html',
  styleUrls: ['./register-student-otp.component.scss']
})
export class RegisterStudentOtpComponent implements OnInit, OnDestroy {
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  phone: any='';
  mobileNumber: string = '';
  submitButtonText: string = 'Submit';
  currentClient: string | null = null;

  ngOnInit(): void {
    // Get current client from URL
    this.currentClient = this.clientService.getClientFromUrl();
    this.startTimer();
  }
  otp: string = "";
  text1: string = "";
  text2: string = "";
  text3: string = "";
  text4: string = "";
  _id: string = ""
  canResend: boolean = false;

  seconds: number = 30;
  private timerInterval: any;

 private sendOtp$: Subscription = new Subscription();
 private verifyOtp$ :Subscription = new Subscription();

  constructor(
      public dialogRef: MatDialogRef<RegisterStudentOtpComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private sanitizer: DomSanitizer,
      private service: AuthService,
      private utilService: UtilService,
      private fb: FormBuilder,
      private _snackBar: MatSnackBar,
      private clientService: ClientService) {
      // console.log(data);

      if (data) {
          this.phone = data.result;
          this.mobileNumber = data.result;
          this.submitButtonText = data.submitButtonText || 'Submit';
          // console.log(this.phone,'asdada')
      }
      // console.log(this.phone,'asdada')
  }

  startTimer() {
    this.seconds = 30;
    this.canResend = false;
    
    this.timerInterval = setInterval(() => {
      if (this.seconds > 0) {
        this.seconds--;
      } else {
        this.canResend = true;
        clearInterval(this.timerInterval);
      }
    }, 1000);
  }

  keytab(event: any) {
    const input = event.target as HTMLInputElement;
    const key = event.key;
    const inputName = input.name as 'text1' | 'text2' | 'text3' | 'text4';

    // Allow input of numbers without preventing default
    if (/^[0-9]$/.test(key)) {
        setTimeout(() => {
            let nextInput = input.nextElementSibling as HTMLInputElement;
            if (nextInput) {
                nextInput.focus();
            }
        }, 0);
        return;
    }

    // Handle backspace
    if (key === 'Backspace' || key === 'Delete') {
        if (input.value === '') {
            let prevInput = input.previousElementSibling as HTMLInputElement;
            if (prevInput) {
                prevInput.focus();
                prevInput.value = '';
                this[prevInput.name as 'text1' | 'text2' | 'text3' | 'text4'] = '';
            }
        } else {
            input.value = '';
            this[inputName] = '';
        }
        event.preventDefault();
        return;
    }

    // Handle left arrow
    if (key === 'ArrowLeft') {
        let prevInput = input.previousElementSibling as HTMLInputElement;
        if (prevInput) {
            prevInput.focus();
        }
        event.preventDefault();
        return;
    }

    // Handle right arrow
    if (key === 'ArrowRight') {
        let nextInput = input.nextElementSibling as HTMLInputElement;
        if (nextInput) {
            nextInput.focus();
        }
        event.preventDefault();
        return;
    }

    // Prevent non-numeric input
    if (!/^[0-9]$/.test(key)) {
        event.preventDefault();
    }
  }

  resend(): boolean {
    this.text1=''
    this.text2=''
    this.text3 =''
    this.text4=''

      if (!this.canResend) {
          return false;
      }

      if (this.phone) {
        // console.log('oKk')

          this.sendOtp$ = this.service.sentOtp({
            phone:this.phone,
            otp_type: this.data?.otpType,
            clientId: this.currentClient
          }).subscribe((resp: any) => {
             
              // this.service.showSuccessMessage({
              //     message: "OTP Sent"
              // })
              this.utilService.showSuccessSnackbar({
                msg:'OTP resent successfully! Please check your SMS.',
                showIcon: false
              });
              this.startTimer();
          },
        (err:any)=>{
          this.utilService.showErrorSnackbar({
            msg: err?.error?.message
          });
        })

      } 

      return true;

  }

  closeDialog() {
    this.dialogRef.close();
  }

  submit(): void {
      this.otp = this.text1 + this.text2 + this.text3 + this.text4
      if (this.otp.length == 4) {
        const obj ={
          otp: parseInt(this.otp),
          phone:this.data?.result,
          otp_type: this.data?.otpType
        }
        if(this.data?.isPrimaryPhoneNumber){
          this.service.otpSubject.next(obj.otp);
        }
        this.verifyOtp$ = this.service.verfifyOtp(obj).subscribe({
          next: (res:any) => {
            if (res.code == 200) {
              this.dialogRef.close({
                match: true,
                otp: obj.otp
              });
            }
          },
          error: (err: any) => {
            this.utilService.showErrorSnackbar({
              msg: err?.error?.message
            });
          }
        });
          
      } else {
          this.service.showErrorMessage({
              message: "Please enter 4 digits OTP"
          });
      }


  }

  moveToNext(event: Event, nextFieldId: string) {
    const input = event.target as HTMLInputElement;
    if (input.value.length === 1 && nextFieldId) {
      setTimeout(() => {
        const nextField = document.getElementById(nextFieldId) as HTMLInputElement;
        nextField?.focus();
      }, 10); // Timeout ensures smooth focus on iOS
    }
  }

  
  handleBackspace(event: KeyboardEvent, prevFieldId: string) {
    const input = event.target as HTMLInputElement;
    if (event.key === 'Backspace' && input.value.length === 0 && prevFieldId) {
      setTimeout(() => {
        const prevField = document.getElementById(prevFieldId) as HTMLInputElement;
        prevField?.focus();
      }, 10); // Timeout ensures smooth focus on iOS
    }
  }

  ngOnDestroy() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    this.sendOtp$?.unsubscribe();
    this.verifyOtp$?.unsubscribe();
  }
  

}


